document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".initially-hidden").forEach((el) => {
    el.classList.remove("initially-hidden");
  });

  initializeLazyImages();
  initializeThemeMeasurements();
});

// Global lazy image loader with skeleton backgrounds
function initializeLazyImages() {
  const lazyImages = document.querySelectorAll(".lazy-fade");

  if (!lazyImages.length) return;

  lazyImages.forEach((img) => {
    // Add skeleton class to wrapper
    const wrapper = img.closest(".lazy-wrapper");
    if (wrapper) {
      wrapper.classList.add("loading");
    }

    // Check if already loaded
    if (img.complete && img.naturalHeight !== 0) {
      handleImageLoad(img, wrapper);
    } else {
      // Listen for load event
      img.addEventListener("load", function () {
        handleImageLoad(img, wrapper);
      });

      // Handle error
      img.addEventListener("error", function () {
        if (wrapper) {
          wrapper.classList.remove("loading");
          wrapper.classList.add("error");
        }
      });
    }
  });
}

function handleImageLoad(img, wrapper) {
  img.classList.add("loaded");
  if (wrapper) {
    wrapper.classList.remove("loading");
    wrapper.classList.add("loaded");
  }
}

function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

function debounceImmediate(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

const html = document.documentElement;

function setElementHeight(element, { heightVar, onUpdate }) {
  if (!element) return;

  const height = element.offsetHeight;

  if (heightVar) {
    html.style.setProperty(heightVar, `${height}px`);
  }

  if (typeof onUpdate === "function") {
    onUpdate(height);
  }
}

function initializeAnnouncement() {
  const announcementBar = document.querySelector(".announcement-bar");
  if (!announcementBar) return;

  const updateAnnouncement = () =>
    setElementHeight(announcementBar, {
      heightVar: "--announcement-height",
      onUpdate: (height) => {
        window.announcementHeight = height;
      },
    });

  updateAnnouncement();

  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver(updateAnnouncement);
    observer.observe(announcementBar);
  } else {
    const debouncedAnnouncement = debounce(updateAnnouncement, 300);
    window.addEventListener("resize", debouncedAnnouncement, {
      passive: true,
    });
  }
}

function initializeHeaderHeight() {
  const mainHeader = document.querySelector(".main-header");
  if (!mainHeader) return;

  const updateHeader = () =>
    setElementHeight(mainHeader, {
      heightVar: "--header-height",
      onUpdate: (height) => {
        window.headerHeight = height;
      },
    });

  updateHeader();

  const throttledHeaderUpdate = throttle(updateHeader, 16);
  window.addEventListener("scroll", throttledHeaderUpdate, {
    passive: true,
  });

  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver(updateHeader);
    observer.observe(mainHeader);
  } else {
    const debouncedHeaderUpdate = debounce(updateHeader, 150);
    window.addEventListener("resize", debouncedHeaderUpdate, {
      passive: true,
    });
  }
}

function initializeNavLinksScroll() {
  const headerLeft = document.querySelector(".header__left");
  const mainHeader = document.querySelector(".main-header");
  if (!headerLeft || !mainHeader) return;

  const handleScroll = () => {
    const scrollY = window.scrollY || window.pageYOffset;
    const headerHeight = mainHeader.offsetHeight;

    if (scrollY >= headerHeight) {
      headerLeft.classList.add("scrolled");
    } else {
      headerLeft.classList.remove("scrolled");
    }
  };

  // Initial check
  handleScroll();

  // Throttled scroll listener
  const throttledScroll = throttle(handleScroll, 16);
  window.addEventListener("scroll", throttledScroll, {
    passive: true,
  });
}

function initializeThemeMeasurements() {
  initializeAnnouncement();
  initializeHeaderHeight();
  initializeNavLinksScroll();
}

// Helper: Calculate luminance (brightness) of a color based on rgb values like this ' 255, 255 , 255 '
function getLuminance(colorStr) {
  const [r, g, b] = colorStr.split(",").map(Number);
  return (r * 299 + g * 587 + b * 114) / 1000; // Weighted luminance
}

// Preloader: Wait for all media to load before hiding
function initializePreloader() {
  const preloader = document.getElementById("preloader");
  if (!preloader) return;

  // Add preloader-active class to body to prevent scrolling
  document.body.classList.add("preloader-active");

  // Function to hide preloader
  function hidePreloader() {
    preloader.classList.add("hidden");

    // Remove overflow hidden after transition completes
    setTimeout(() => {
      document.body.classList.remove("preloader-active");
      // Reset any inline styles that might interfere
      document.body.style.height = "";
      // Ensure scrollbar space is maintained
      document.documentElement.style.scrollbarGutter = "stable";
    }, 600); // Match transition duration
  }

  // Check if all media is loaded
  function checkMediaLoaded() {
    const images = document.querySelectorAll("img");
    const videos = document.querySelectorAll("video");
    const iframes = document.querySelectorAll("iframe");

    let loadedCount = 0;
    let totalMedia = images.length + videos.length + iframes.length;

    // If no media, hide immediately
    if (totalMedia === 0) {
      // Wait a minimum time for smooth animation
      setTimeout(hidePreloader, 500);
      return;
    }

    // Track loaded media
    function onMediaLoad() {
      loadedCount++;
      if (loadedCount >= totalMedia) {
        // All media loaded, hide preloader
        setTimeout(hidePreloader, 300);
      }
    }

    // Check images
    images.forEach((img) => {
      if (img.complete && img.naturalHeight !== 0) {
        onMediaLoad();
      } else {
        img.addEventListener("load", onMediaLoad, { once: true });
        img.addEventListener("error", onMediaLoad, { once: true }); // Count errors as loaded
      }
    });

    // Check videos
    videos.forEach((video) => {
      if (video.readyState >= 3) {
        // HAVE_FUTURE_DATA or higher
        onMediaLoad();
      } else {
        video.addEventListener("canplaythrough", onMediaLoad, { once: true });
        video.addEventListener("error", onMediaLoad, { once: true });
      }
    });

    // Check iframes
    iframes.forEach((iframe) => {
      if (
        iframe.contentDocument &&
        iframe.contentDocument.readyState === "complete"
      ) {
        onMediaLoad();
      } else {
        iframe.addEventListener("load", onMediaLoad, { once: true });
        iframe.addEventListener("error", onMediaLoad, { once: true });
      }
    });

    // Fallback: Hide preloader after maximum wait time (5 seconds)
    setTimeout(() => {
      if (!preloader.classList.contains("hidden")) {
        hidePreloader();
      }
    }, 5000);
  }

  // Wait for DOM to be fully ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      // Small delay to ensure all elements are in DOM
      setTimeout(checkMediaLoaded, 100);
    });
  } else {
    // DOM already ready
    setTimeout(checkMediaLoaded, 100);
  }

  // Also listen for window load as fallback
  window.addEventListener("load", () => {
    setTimeout(() => {
      if (!preloader.classList.contains("hidden")) {
        hidePreloader();
      }
    }, 300);
  });
}
